var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonaElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3488 44.3521C37.3324 44.3521 47.047 34.6374 47.047 22.6538C47.047 10.6702 37.3324 0.955566 25.3488 0.955566C13.3652 0.955566 3.65051 10.6702 3.65051 22.6538C3.65051 34.6374 13.3652 44.3521 25.3488 44.3521Z",
    fill: "url(#paint0_linear_221_35103)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3495 0C12.931 0 2.86658 10.0644 2.86658 22.4829C2.86658 34.9014 12.931 44.9659 25.3495 44.9659C37.768 44.9659 47.8325 34.9014 47.8325 22.4829C47.8325 10.0644 37.768 0 25.3495 0ZM25.3495 43.7377C19.6861 43.7377 14.3639 41.5201 10.3381 37.5284C6.31237 33.5027 4.1289 28.1804 4.1289 22.5171C4.1289 16.8537 6.34649 11.5315 10.3381 7.50569C14.3298 3.47991 19.6861 1.29644 25.3495 1.29644C31.0129 1.29644 36.3351 3.51403 40.3609 7.50569C44.3867 11.5315 46.5701 16.8537 46.5701 22.5171C46.5701 28.1804 44.3526 33.5027 40.3609 37.5284C36.3692 41.5201 31.0129 43.7377 25.3495 43.7377Z",
    fill: "url(#paint1_linear_221_35103)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.3482 44.386C15.1814 44.386 6.58395 37.7674 3.71814 28.6582C6.37925 38.1085 15.079 45.0001 25.3482 45.0001C35.6173 45.0001 44.3171 38.0744 46.9782 28.6582C44.1124 37.7674 35.515 44.386 25.3482 44.386Z",
    fill: "url(#paint2_linear_221_35103)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8031 7.06239C36.675 2.93426 31.1822 0.648438 25.3482 0.648438C19.5142 0.648438 14.0556 2.93426 9.92744 7.06239C5.79931 11.1905 3.51349 16.6492 3.51349 22.4832C3.51349 28.3171 5.79931 33.8099 9.89332 37.9039C14.0215 42.0321 19.5142 44.2838 25.3141 44.2838C31.1139 44.2838 36.6409 41.9979 40.7349 37.9039C44.863 33.7758 47.1147 28.283 47.1147 22.4832C47.1147 16.6833 44.8971 11.1905 40.8031 7.06239ZM40.3596 37.4945C36.3338 41.5203 31.0116 43.7038 25.3482 43.7038C19.6848 43.7038 14.3626 41.4862 10.3368 37.4945C6.31106 33.4688 4.12759 28.1465 4.12759 22.4832C4.12759 16.8198 6.34518 11.4976 10.3368 7.47179C14.3285 3.44601 19.6848 1.26254 25.3482 1.26254C31.0116 1.26254 36.3338 3.48013 40.3596 7.47179C44.3854 11.4976 46.5688 16.8198 46.5688 22.4832C46.5688 28.1465 44.3854 33.5029 40.3596 37.4945Z",
    fill: "url(#paint3_linear_221_35103)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.0123 16.3419C44.3171 6.9257 35.6514 0 25.3482 0C15.0449 0 6.37925 6.9257 3.71814 16.3419C6.61806 7.23275 15.1814 0.682335 25.3482 0.682335C35.515 0.682335 44.1124 7.23275 47.0123 16.3419Z",
    fill: "url(#paint4_linear_221_35103)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.19867 33.7422L7.77865 35.448C7.77865 35.448 7.91512 35.9257 7.6763 36.4033L9.00686 37.9385L8.83627 35.8233C8.87039 35.8574 7.19867 33.7422 7.19867 33.7422Z",
    fill: "url(#paint5_linear_221_35103)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20987 6.14154C8.22049 9.48498 6.75347 12.112 6.75347 12.112C6.4123 12.8625 5.96878 13.8519 5.96878 13.8519C5.76408 14.2613 5.42291 15.1484 5.42291 15.1484C6.37818 14.0907 7.0264 13.1696 7.74285 12.1802C9.17576 10.3038 10.131 7.02857 10.6087 5.11803C10.8134 4.231 10.9498 3.6169 10.9498 3.6169C11.7686 3.20749 12.2121 2.96868 12.2463 2.93456C12.3145 2.90044 12.4168 2.86633 12.4851 2.83221C12.1439 2.38869 11.7345 2.04752 11.7345 2.04752C10.4722 1.84282 9.92632 2.55928 9.92632 2.55928C9.85809 3.20749 9.75574 3.8216 9.61927 4.40158C9.48281 5.0498 9.34634 5.62978 9.20987 6.14154Z",
    fill: "url(#paint6_linear_221_35103)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93451 13.8518C5.93451 13.8518 6.65096 12.2483 6.68508 12.1801C6.68508 12.1801 8.18622 9.48489 9.1756 6.14145C9.34618 5.59558 9.48265 5.04971 9.61912 4.46973C9.61912 4.46973 9.89205 8.93902 5.93451 13.8518Z",
    fill: "url(#paint7_linear_221_35103)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.714 5.42505C10.714 5.42505 10.5434 5.59563 10.0999 7.02854C10.0999 7.02854 10.2705 5.01565 10.7822 3.41216C10.7822 3.41216 11.3281 2.38866 11.7716 2.11572C11.8399 2.18396 12.3516 2.52512 13.1363 3.61686C13.0681 3.65098 12.8293 3.82156 12.761 3.88979C12.6587 3.92391 11.874 4.46978 10.714 5.42505Z",
    fill: "url(#paint8_linear_221_35103)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.92828 2.62831C9.92828 2.62831 10.3718 2.01421 11.4635 2.08244C11.02 2.73066 10.133 2.86713 9.92828 2.62831Z",
    fill: "url(#paint9_linear_221_35103)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7105 5.42531L11.0517 4.47004C11.4952 3.89006 12.0069 3.58301 12.0069 3.58301C12.0069 3.58301 12.4505 3.65124 12.894 3.78771L12.7575 3.89006C11.6658 4.57239 10.7105 5.42531 10.7105 5.42531Z",
    fill: "url(#paint10_linear_221_35103)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.17458 14.2619C6.17458 14.2619 6.44751 13.5454 6.65221 12.8972L6.95926 11.7031C6.92515 11.7714 6.78868 12.0784 6.72045 12.1125C6.17458 13.2043 5.86753 13.9207 5.38989 15.1489C5.42401 15.1489 5.96988 14.5007 6.17458 14.2619Z",
    fill: "url(#paint11_linear_221_35103)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51403 17.0593C3.51403 17.0593 1.94466 18.6969 1.0235 22.4838H0C0 22.4838 0.238817 18.3216 4.23048 14.7734L3.51403 17.0593Z",
    fill: "url(#paint12_linear_221_35103)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20987 38.8247C8.22049 35.4813 6.75347 32.8543 6.75347 32.8543C6.4123 32.1037 5.96878 31.1143 5.96878 31.1143C5.76408 30.7049 5.42291 29.8179 5.42291 29.8179C6.37818 30.8755 7.0264 31.7966 7.74285 32.786C9.17576 34.6283 10.131 37.9377 10.6087 39.8482C10.8134 40.7352 10.9498 41.3493 10.9498 41.3493C11.7686 41.7587 12.2121 41.9976 12.2463 42.0317C12.3145 42.0658 12.4168 42.0999 12.4851 42.134C12.1439 42.5775 11.7345 42.9187 11.7345 42.9187C10.4722 43.1234 9.92632 42.407 9.92632 42.407C9.85809 41.7587 9.75574 41.1446 9.61927 40.5646C9.48281 39.9164 9.34634 39.3706 9.20987 38.8247Z",
    fill: "url(#paint13_linear_221_35103)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93451 31.1152C5.93451 31.1152 6.65096 32.7187 6.68508 32.787C6.68508 32.787 8.18622 35.4822 9.1756 38.8256C9.34618 39.3715 9.48265 39.9174 9.61912 40.4973C9.61912 40.4973 9.89205 36.0622 5.93451 31.1152Z",
    fill: "url(#paint14_linear_221_35103)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5753 39.4392C10.5753 39.4392 10.5412 39.4051 10.0636 37.9722C10.0636 37.9722 10.2342 39.9851 10.7459 41.5885C10.7459 41.5885 11.2918 42.612 11.7353 42.885C11.8036 42.8167 12.8953 41.8615 13.2023 41.4521C13.1341 41.418 12.6224 41.0427 12.5541 41.0086C12.52 40.9744 11.5647 40.3603 10.5753 39.4392Z",
    fill: "url(#paint15_linear_221_35103)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92828 42.373C9.92828 42.373 10.3718 42.9871 11.4635 42.9189C11.02 42.2707 10.133 42.1001 9.92828 42.373Z",
    fill: "url(#paint16_linear_221_35103)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5752 39.4395L10.8481 40.2241C11.0528 40.9406 11.5646 41.4865 11.5646 41.4865C11.5646 41.4865 11.9399 41.5547 12.2469 41.3841L12.6563 41.0771C12.4857 40.9747 11.2916 40.0536 10.5752 39.4395Z",
    fill: "url(#paint17_linear_221_35103)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.17458 30.7393C6.17458 30.7393 6.44751 31.4558 6.65221 32.104L6.95926 33.2981C6.92515 33.2299 6.78868 32.9228 6.72045 32.8887C6.17458 31.797 5.86753 31.0805 5.38989 29.8523C5.42401 29.8182 5.96988 30.5005 6.17458 30.7393Z",
    fill: "url(#paint18_linear_221_35103)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51403 27.908C3.51403 27.908 1.94466 26.2704 1.0235 22.4834H0C0 22.4834 0.238817 26.6456 4.23048 30.1938L3.51403 27.908Z",
    fill: "url(#paint19_linear_221_35103)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02335 22.4837C1.91038 18.7991 3.51387 17.0591 3.51387 17.0591L3.92327 15.7627C0.989231 18.5603 0.511597 22.5178 0.511597 22.5178C0.511597 22.5178 0.989231 26.4754 3.92327 29.2388L3.51387 27.9424C3.51387 27.9083 1.91038 26.1683 1.02335 22.4837Z",
    fill: "url(#paint20_linear_221_35103)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.17188 27.4644C3.17188 27.4644 3.30834 28.2149 3.27423 28.5561L3.51304 29.5455L4.22949 30.2278L3.92244 29.2384L3.51304 27.942L3.17188 27.4644Z",
    fill: "url(#paint21_linear_221_35103)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.22949 14.7729L3.92244 15.7623L3.51304 17.0588L3.17188 17.5364V16.547L3.92244 15.0459L4.22949 14.7729Z",
    fill: "url(#paint22_linear_221_35103)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.499 33.7422L42.919 35.448C42.919 35.448 42.7825 35.9257 43.0213 36.4033L41.6908 37.9385L41.8614 35.8233C41.8614 35.8574 43.499 33.7422 43.499 33.7422Z",
    fill: "url(#paint23_linear_221_35103)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5172 6.14202C42.5065 9.48547 43.9736 12.1125 43.9736 12.1125C44.3147 12.863 44.7582 13.8524 44.7582 13.8524C44.9629 14.2618 45.3041 15.1488 45.3041 15.1488C44.3488 14.0912 43.7006 13.1701 42.9842 12.1807C41.5513 10.3043 40.596 7.02906 40.1184 5.11852C39.8795 4.23149 39.7772 3.61738 39.7772 3.61738C38.9584 3.20798 38.5149 2.96917 38.4808 2.93505C38.4125 2.90093 38.3443 2.86681 38.2419 2.8327C38.5831 2.38918 38.9925 2.04801 38.9925 2.04801C40.2548 1.84331 40.8007 2.55976 40.8007 2.55976C40.8689 3.20798 40.9713 3.82208 41.1078 4.40207C41.2101 5.05029 41.3466 5.63027 41.5172 6.14202Z",
    fill: "url(#paint24_linear_221_35103)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7592 13.8523C44.7592 13.8523 44.0427 12.2488 44.0086 12.1806C44.0086 12.1806 42.5075 9.48538 41.5181 6.14194C41.3475 5.59607 41.211 5.0502 41.0746 4.47021C41.0746 4.47021 40.8016 8.93951 44.7592 13.8523Z",
    fill: "url(#paint25_linear_221_35103)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9832 5.42554C39.9832 5.42554 40.1197 5.59612 40.5973 7.02902C40.5973 7.02902 40.4267 5.01614 39.915 3.41265C39.915 3.41265 39.3691 2.38914 38.9597 2.11621C38.8915 2.18444 38.3797 2.52561 37.595 3.61735C37.6633 3.65147 37.9021 3.82205 37.9703 3.89028C38.0386 3.9244 38.8232 4.47027 39.9832 5.42554Z",
    fill: "url(#paint26_linear_221_35103)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.7674 2.62831C40.7674 2.62831 40.3239 2.01421 39.2321 2.08244C39.6756 2.73066 40.5627 2.86713 40.7674 2.62831Z",
    fill: "url(#paint27_linear_221_35103)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9832 5.42531L39.642 4.47004C39.1985 3.89006 38.6867 3.58301 38.6867 3.58301C38.6867 3.58301 38.2432 3.65124 37.7997 3.78771L37.9361 3.89006C39.0279 4.57239 39.9832 5.42531 39.9832 5.42531Z",
    fill: "url(#paint28_linear_221_35103)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.5222 14.2624C44.5222 14.2624 44.2492 13.5459 44.0445 12.8977L43.7375 11.7036C43.7716 11.7718 43.9081 12.0789 43.9763 12.113C44.5222 13.2048 44.8292 13.9212 45.3069 15.1494C45.3069 15.1494 44.7269 14.5012 44.5222 14.2624Z",
    fill: "url(#paint29_linear_221_35103)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1803 17.0597C47.1803 17.0597 48.7496 18.6974 49.6708 22.4843H50.6943C50.6943 22.4843 50.4555 18.3221 46.4638 14.7739L47.1803 17.0597Z",
    fill: "url(#paint30_linear_221_35103)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5209 38.8262C42.5103 35.4827 43.9773 32.8557 43.9773 32.8557C44.3184 32.1052 44.762 31.1158 44.762 31.1158C44.9667 30.7064 45.3078 29.8193 45.3078 29.8193C44.3526 30.877 43.7043 31.7981 42.9879 32.7875C41.555 34.6298 40.5997 37.9391 40.1221 39.8497C39.8833 40.7367 39.7809 41.3508 39.7809 41.3508C38.9621 41.7602 38.5186 41.999 38.4845 42.0331C38.4163 42.0673 38.348 42.1014 38.2457 42.1355C38.5868 42.579 38.9962 42.9202 38.9962 42.9202C40.2586 43.1249 40.8044 42.4084 40.8044 42.4084C40.8727 41.7602 40.975 41.1461 41.1115 40.5661C41.2138 39.9179 41.3503 39.372 41.5209 38.8262Z",
    fill: "url(#paint31_linear_221_35103)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7629 31.1157C44.7629 31.1157 44.0464 32.7192 44.0123 32.7874C44.0123 32.7874 42.5112 35.4827 41.5218 38.8261C41.3512 39.372 41.2148 39.9178 41.0783 40.4978C41.0783 40.4978 40.8054 36.0627 44.7629 31.1157Z",
    fill: "url(#paint32_linear_221_35103)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1223 39.4397C40.1223 39.4397 40.1564 39.4056 40.634 37.9727C40.634 37.9727 40.4635 39.9855 39.9517 41.589C39.9517 41.589 39.4058 42.6125 38.9964 42.8855C38.9282 42.8172 37.8365 41.862 37.5294 41.4526C37.5977 41.4184 38.1094 41.0432 38.1776 41.009C38.2118 40.9749 39.1329 40.3608 40.1223 39.4397Z",
    fill: "url(#paint33_linear_221_35103)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7711 42.3735C40.7711 42.3735 40.3276 42.9876 39.2358 42.9194C39.6794 42.2712 40.5664 42.1006 40.7711 42.3735Z",
    fill: "url(#paint34_linear_221_35103)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1221 39.4399L39.8492 40.2246C39.6445 40.9411 39.1328 41.4869 39.1328 41.4869C39.1328 41.4869 38.7575 41.5552 38.4504 41.3846L38.041 41.0775C38.2457 40.9752 39.4398 40.054 40.1221 39.4399Z",
    fill: "url(#paint35_linear_221_35103)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.5225 30.7398C44.5225 30.7398 44.2496 31.4563 44.0449 32.1045L43.7379 33.2986C43.772 33.2304 43.9084 32.9233 43.9767 32.8892C44.5225 31.7975 44.8296 31.081 45.3072 29.8528C45.3072 29.8187 44.7272 30.501 44.5225 30.7398Z",
    fill: "url(#paint36_linear_221_35103)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1852 27.9085C47.1852 27.9085 48.7546 26.2708 49.6757 22.4839H50.6992C50.6992 22.4839 50.4604 26.6461 46.4688 30.1943L47.1852 27.9085Z",
    fill: "url(#paint37_linear_221_35103)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6756 22.4842C48.7886 18.7996 47.1851 17.0596 47.1851 17.0596L46.7757 15.7632C49.7097 18.5608 50.1874 22.4842 50.1874 22.4842C50.1874 22.4842 49.7097 26.4417 46.7757 29.2052L47.1851 27.9087C47.1851 27.9087 48.7886 26.1688 49.6756 22.4842Z",
    fill: "url(#paint38_linear_221_35103)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.5574 27.4648C47.5574 27.4648 47.421 28.2154 47.4551 28.5566L47.2163 29.546L46.4998 30.2283L46.8069 29.2389L47.2163 27.9425L47.5574 27.4648Z",
    fill: "url(#paint39_linear_221_35103)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.4668 14.7729L46.7739 15.7623L47.1833 17.0588L47.5585 17.5364V16.547L46.7739 15.0459L46.4668 14.7729Z",
    fill: "url(#paint40_linear_221_35103)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5958 14.5168C37.5747 14.3376 37.5465 14.1727 37.5254 14.0365C37.5183 13.9792 37.4267 13.9935 37.4267 14.0508C37.4408 14.6745 37.6663 15.5919 37.3211 16.1654C36.7997 17.0184 35.7148 16.1439 35.2005 15.721C34.2283 14.9182 33.2702 14.015 31.9316 14.015C30.5508 14.015 29.4236 14.7318 28.4232 15.6278C27.9371 16.065 27.3524 16.5094 27.0354 17.0972C26.8522 17.4341 26.7113 17.8283 26.352 18.0219C26.2393 18.0864 26.1195 18.1294 25.9998 18.1581C25.88 18.1294 25.7602 18.0864 25.6475 18.0219C25.2953 17.8283 25.1544 17.4341 24.9642 17.0972C24.6401 16.5094 24.0624 16.065 23.5763 15.6278C22.5689 14.7318 21.4417 14.015 20.0679 14.015C18.7293 14.015 17.7783 14.9182 16.799 15.721C16.2847 16.1439 15.1998 17.0184 14.6785 16.1654C14.3333 15.5919 14.5587 14.6745 14.5728 14.0508C14.5728 13.9935 14.4812 13.9792 14.4742 14.0365C14.453 14.1799 14.4319 14.3447 14.4037 14.5168C13.5442 18.2512 14.1008 22.3011 15.6577 25.7632C16.0663 26.6736 16.5454 27.5911 17.1513 28.3795C17.6796 29.0677 18.3348 29.6124 19.0605 30.0712C20.5258 30.9958 22.1884 31.5406 23.6397 32.5011C24.1188 32.8165 24.5274 33.2107 24.9642 33.5835C25.26 33.8343 25.6264 34.0135 26.0068 33.9992C26.3872 34.0135 26.7465 33.8343 27.0495 33.5835C27.4863 33.2107 27.8949 32.8165 28.3739 32.5011C29.8252 31.5478 31.4878 31.003 32.9532 30.0712C33.6788 29.6124 34.334 29.0677 34.8624 28.3795C35.4682 27.5911 35.9473 26.6736 36.3559 25.7632C37.8987 22.294 38.4553 18.2512 37.5958 14.5168ZM28.536 27.4119C28.2823 26.9603 28.2894 26.394 28.3528 25.8923C28.4373 25.2328 28.7191 24.7024 29.2616 24.3082C30.114 23.6845 31.2271 23.0108 32.305 22.9749C33.3406 22.9391 34.4538 23.6129 35.4753 23.2401C35.7993 23.1183 36.0882 22.9176 36.3066 22.6524C36.06 23.2186 35.7078 23.7347 35.278 24.1935C34.6369 24.8744 33.8972 25.5195 33.1363 26.0643C32.3262 26.6449 31.4033 26.8814 30.4522 27.118C29.8111 27.2685 29.1771 27.3832 28.536 27.4119ZM23.4706 27.4119C22.8295 27.3832 22.1955 27.2757 21.5473 27.1108C20.5963 26.8743 19.6734 26.6377 18.8632 26.0571C18.1023 25.5124 17.3697 24.8673 16.7215 24.1863C16.2918 23.7347 15.9395 23.2186 15.693 22.6452C15.9114 22.9104 16.2002 23.1183 16.5243 23.233C17.5458 23.6057 18.6589 22.9319 19.6945 22.9677C20.7653 23.0036 21.8855 23.6845 22.7379 24.301C23.2734 24.6952 23.5552 25.2256 23.6467 25.8851C23.7172 26.394 23.7242 26.9603 23.4706 27.4119Z",
    fill: "#BF96FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_221_35103",
    x1: -3.63703,
    y1: 2.93836,
    x2: 32.2303,
    y2: 27.3147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F1EFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C7C2CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A198A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3E2C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2C1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_221_35103",
    x1: 25.3563,
    y1: 0,
    x2: 25.3563,
    y2: 44.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_221_35103",
    x1: 25.355,
    y1: 28.6275,
    x2: 25.355,
    y2: 44.9831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_221_35103",
    x1: 25.355,
    y1: 44.3247,
    x2: 25.355,
    y2: 0.658671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_221_35103",
    x1: 25.3533,
    y1: 16.3555,
    x2: 25.3533,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_221_35103",
    x1: 8.11812,
    y1: 22.1084,
    x2: 8.11812,
    y2: 29.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_221_35103",
    x1: 4.41493,
    y1: 6.52851,
    x2: 10.4274,
    y2: 9.74684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_221_35103",
    x1: 10.5847,
    y1: 10.7754,
    x2: 5.25505,
    y2: 7.92252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_221_35103",
    x1: 11.8386,
    y1: 5.17147,
    x2: 9.93167,
    y2: 4.15075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_221_35103",
    x1: 10.143,
    y1: 2.17159,
    x2: 11.7251,
    y2: 3.01845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_221_35103",
    x1: 15.4382,
    y1: 6.67416,
    x2: 13.4742,
    y2: 5.62285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_221_35103",
    x1: 6.11307,
    y1: 13.5009,
    x2: 6.57326,
    y2: 13.7473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_221_35103",
    x1: 1.6491,
    y1: 19.5231,
    x2: 0.151376,
    y2: 22.4845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_221_35103",
    x1: 4.49551,
    y1: 38.3076,
    x2: 10.508,
    y2: 35.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_221_35103",
    x1: 10.6696,
    y1: 34.0624,
    x2: 5.33685,
    y2: 36.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_221_35103",
    x1: 11.965,
    y1: 39.6391,
    x2: 9.9979,
    y2: 40.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_221_35103",
    x1: 10.2266,
    y1: 42.6639,
    x2: 11.8087,
    y2: 41.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_221_35103",
    x1: 15.3208,
    y1: 38.1162,
    x2: 13.3898,
    y2: 39.1498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_221_35103",
    x1: 6.19368,
    y1: 31.3361,
    x2: 6.65678,
    y2: 31.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_221_35103",
    x1: -0.0631841,
    y1: 27.9294,
    x2: 2.03841,
    y2: 26.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_221_35103",
    x1: 6.63883,
    y1: 24.4081,
    x2: 1.03686,
    y2: 20.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_221_35103",
    x1: 3.68704,
    y1: 19.8631,
    x2: 3.68704,
    y2: 24.6497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_221_35103",
    x1: 3.69045,
    y1: 7.17515,
    x2: 3.69045,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_221_35103",
    x1: 42.5897,
    y1: 22.1084,
    x2: 42.5897,
    y2: 29.4435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_221_35103",
    x1: 46.1902,
    y1: 6.56275,
    x2: 40.1777,
    y2: 9.78113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_221_35103",
    x1: 40.0219,
    y1: 10.8112,
    x2: 45.3517,
    y2: 7.95834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_221_35103",
    x1: 38.7716,
    y1: 5.20732,
    x2: 40.6786,
    y2: 4.18655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_221_35103",
    x1: 40.4657,
    y1: 2.20686,
    x2: 38.8835,
    y2: 3.05376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_221_35103",
    x1: 32.4809,
    y1: 6.36687,
    x2: 40.5051,
    y2: 4.16975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_221_35103",
    x1: 44.4966,
    y1: 13.5366,
    x2: 44.0365,
    y2: 13.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_221_35103",
    x1: 49.0546,
    y1: 19.5223,
    x2: 50.5524,
    y2: 22.4836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_221_35103",
    x1: 46.1134,
    y1: 38.2752,
    x2: 40.101,
    y2: 35.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_221_35103",
    x1: 39.9407,
    y1: 34.0278,
    x2: 45.2734,
    y2: 36.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_221_35103",
    x1: 38.6488,
    y1: 39.6059,
    x2: 40.6128,
    y2: 40.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_221_35103",
    x1: 40.3859,
    y1: 42.6291,
    x2: 38.8037,
    y2: 41.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_221_35103",
    x1: 35.2926,
    y1: 38.083,
    x2: 37.2205,
    y2: 39.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_221_35103",
    x1: 44.4165,
    y1: 31.3013,
    x2: 43.9534,
    y2: 31.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_221_35103",
    x1: 50.7704,
    y1: 27.9283,
    x2: 48.6689,
    y2: 26.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_221_35103",
    x1: 44.0669,
    y1: 24.4083,
    x2: 49.6721,
    y2: 20.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85769C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98AAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_221_35103",
    x1: 47.0133,
    y1: 19.8636,
    x2: 47.0133,
    y2: 24.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_221_35103",
    x1: 47.0126,
    y1: 7.17515,
    x2: 47.0126,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5BA4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonaElement);
export default __webpack_public_path__ + "static/media/persona-element.7ccf8919013a1a2e8833613bd24ab3a5.svg";
export { ForwardRef as ReactComponent };